/**
 * 用户访问记录
 */
<template>
  <div>
    
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>小程序访问记录</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" ref="formInline" class="user-search">
      <el-form-item label="搜索：" prop="keyword">
        <el-input size="small" clearable style="width: 300px" v-model="formInline.keyword" placeholder="输入关键字"></el-input>
      </el-form-item>
      <el-form-item label="" prop="date_time">
        <el-date-picker
          v-model="formInline.date_time"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="resetForm('formInline')">重置</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="username" label="用户昵称" width="240">
      </el-table-column>
      <el-table-column sortable prop="description" label="访问模块" width="240">
      </el-table-column>
      <el-table-column sortable prop="visittime" label="访问时间" width="240">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog title="查看" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-form-item label="用户昵称" prop="username">
          <el-input size="small"  v-model="editForm.username" readonly auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="访问模块" prop="description">
          <el-input size="small" type="textarea" :rows="4" v-model="editForm.description" readonly auto-complete="off" ></el-input>
        </el-form-item>
        <el-form-item label="访问时间" prop="visittime">
          <el-input size="small" v-model="editForm.visittime" readonly auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { VisitLogList } from '../../api/businessMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        id:'',
        description: '',
        visittime: '',
        username : '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        keyword: '',
        date_time:[],
        startTime: '',
        endTime: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      VisitLogList(parameter)
        .then(res => {
          this.loading = false
         if (res.result != 'success') {
            this.$message({
              type: 'info',
              message: '请求失败'
            })
          } else {
            this.listData = res.list
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.response.statusText)
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      //时间段为空，则开始和结束时间都为空
      if(this.formInline.date_time[0]) {

        this.formInline.startTime = this.formInline.date_time[0]
      }else{
        this.formInline.startTime = ''
      }
      if(this.formInline.date_time[1]) {
        this.formInline.endTime = this.formInline.date_time[1]
        
      }else{
        this.formInline.endTime = ''
      }
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.editForm.username = row.username
        this.editForm.visittime = row.visittime
        this.editForm.description = row.description
      } else {
      }
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    //重置
    resetForm(formName) {
        this.$refs[formName].resetFields();
        console.log(this.formInline.startTime)
        console.log(this.formInline.endTime)
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/miniBusiness/VisitLog.vue